module.exports = __webpack_public_path__ + "img/icon-ig.1ca86899.svg";